import { render, staticRenderFns } from "./PictoPage.vue?vue&type=template&id=516fd99c&scoped=true&"
import script from "./PictoPage.vue?vue&type=script&lang=js&"
export * from "./PictoPage.vue?vue&type=script&lang=js&"
import style0 from "./PictoPage.vue?vue&type=style&index=0&id=516fd99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516fd99c",
  null
  
)

export default component.exports